import axios from "../../utils/axios";

export const getBlog = async (id) => {
  const response = await axios.get(`/blogs/${id}`);

  return response.data;
};

export const getUpdatedBlog = async (id, likes) => {
  try {
    const response = await axios.patch(`/blogs/${id}`, {
      likes: likes,
    });

    return response.data;
  } catch (error) {
    console.error("Error updating blog:", error);
    throw error;
  }
};

export const getSavedBlog = async (id, isSaved) => {
  try {
    const response = await axios.patch(`/blogs/${id}`, {
      isSaved: isSaved,
    });

    return response.data;
  } catch (error) {
    console.error("Error updating blog:", error);
    throw error;
  }
};
